import { Box, Button } from '@mui/material'
import React from 'react'

export default function FooterBtn({
  handleClick,
  title,
}: {
  handleClick: () => void
  title: string
}) {
  return (
    <Box display="flex" justifyContent="flex-end">
      <Button
        color="primary"
        variant="contained"
        disableElevation
        onClick={handleClick}
        sx={{
          height: (theme) => theme.spacing(8),
          width: '100%',
          borderRadius: 0,
          boxShadow: '2px 0px 8px rgba(0, 0, 0, 0.08)',
          fontSize: '0.9375rem',
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Button>
    </Box>
  )
}
